$(document).ready(function() {

    // Slick carousel
    if ($.fn.slick) {
        $('.hero-carousel').each(function () {
            var $self = $(this);
            var $widget = $self.parents('.widget');

            var totalSlides = $widget.find('.slide-item').length;

            // Control carousel items with data-min / data-max attributes
            var minSlides = $self.data('min') || 1,
                maxSlides = $self.data('max') || 0;

            // Ensure max isn't greater than number of items
            if (maxSlides > totalSlides) {
                maxSlides = totalSlides;
            }

            var options = {
                infinite: false,
                rows: 0,
                speed: 600,
                mobileFirst: true,
                cssEase: 'ease-out',
                arrows: false,
                dots: false,
                useTransform: true,
                slidesToShow: minSlides,
                slidesToScroll: minSlides,
                responsive: [],
                autoplay: true,
                autoplaySpeed: 4000
            };

            if ($self.parents('.widget.widget-carousel-fade').length) {
                options.fade = true;
            }

            if ($self.data('dots')) {
                options.dots = true;
                var appendDots = $self.parent().find($self.data('dots'));
                if (appendDots.length) {
                    options.appendDots = appendDots;
                }
            }

            if ($self.data('arrows')) {
                options.arrows = true;
                var appendArrows = $self.parent().find($self.data('arrows'));
                if (appendArrows.length) {
                    options.appendArrows = appendArrows;
                }
            }

            if (maxSlides && maxSlides > 2) {
                options.responsive.push({
                    breakpoint: 580,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                });
            }

            const arrayObjects = [];
            switch ($self.data('size')) {
                case 'sm':
                    arrayObjects.push({name: 'sm', scroll: 2, size: 425});
                    arrayObjects.push({name: 'md', scroll: 3, size: 768});
                    arrayObjects.push({name: 'lg', scroll: 5, size: 1024});
                    arrayObjects.push({name: 'xl', scroll: 5, size: 1440});
                    break;
                default:
                    arrayObjects.push({name: 'md', scroll: 2, size: 992});
                    arrayObjects.push({name: 'lg', scroll: 3, size: 1200});
                    arrayObjects.push({name: 'xl', scroll: 4, size: 1800});
            }

            for (var i = 0; i < arrayObjects.length; i++) {
                var arrayObject = arrayObjects[i];

                if ($self.hasClass('carousel-' + arrayObject.name + '-default') || $widget.hasClass('carousel-' + arrayObject.name + '-default')) {
                    options.responsive.push({
                        breakpoint: arrayObject.size,
                        settings: "unslick"
                    })
                } else if (maxSlides && maxSlides >= arrayObject.scroll) {
                    options.responsive.push({
                        breakpoint: arrayObject.size,
                        settings: {
                            slidesToShow: arrayObject.scroll,
                            slidesToScroll: arrayObject.scroll
                        }
                    })
                }
            }

            $self.slick(options);

            if ($self.hasClass('slick-lightbox')) {
                $self.slickLightbox({
                    src: 'data-remote',
                    itemSelector: 'img',
                    caption: function (element, info) {
                        return $(element).attr('alt')
                    }
                });
            }

            // Fires before slide change
            $self.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $self.addClass('slick-sliding')
            }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
                $self.removeClass('slick-sliding');
            })

            $self.on('init', intiCarousel)
                .on('breakpoint', intiCarousel);

            function intiCarousel(event, slick, breakpoint) {
                // Center items if less than max slides to show - https://github.com/kenwheeler/slick/issues/262
                $self.toggleClass('slick-no-slide', slick.slideCount <= slick.options.slidesToShow);
            }
        });
    }
});
